// Copyright (c) 2019 Deere & Company

import EditableField from './editable-field';
import LabeledFormInput from './labeled-form-input';
import PropTypes from 'prop-types';
import React from 'react';

const LabeledTextarea = ( {
    className, highlightClass, isEditable, value, formatter, label, type = 'text', vsrMessage, ...props
} ) => (
    <LabeledFormInput
        className={`${className} ${highlightClass}`}
        label={label}
    >
        <EditableField
            isEditable={isEditable}
            value={formatter ? formatter( value ) : value}
        >
            <textarea
                {...props}
                onChange={props.onChange}
                type={type}
                value={value}
                disabled={props.disabled}
            />
        </EditableField>
    </LabeledFormInput>
);

LabeledTextarea.displayName = 'LabeledTextarea';
LabeledTextarea.propTypes = {
    className: PropTypes.string.isRequired,
    formatter: PropTypes.func,
    highlightClass: PropTypes.string,
    isEditable: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    type: PropTypes.string,
    value: PropTypes.oneOfType( [PropTypes.string, PropTypes.number] ),
    vsrMessage: PropTypes.string,
    disabled: PropTypes.bool,
};

export default LabeledTextarea;
